import { Injectable, signal, effect, computed } from '@angular/core';
import { ThemeConstant } from '@constant/theme';
import { Theme } from '@model/core/theme.model';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  public theme = signal<Theme>({ mode: 'light', color: 'orange' });

  public colorCode = computed(() => {
    const color = ThemeConstant.colors.find(
      (c) => c.name === this.theme().color
    );
    return color ? color.code : ThemeConstant.colors[0].code;
  });

  public isDark = computed(() => this.theme().mode == 'dark');

  constructor() {
    this._loadTheme();

    effect(() => {
      this._setTheme();
    });
  }

  private _loadTheme(): void {
    const theme = localStorage.getItem('theme');

    if (theme) {
      this.theme.set(JSON.parse(theme));
    } else {
      const prefersDark = window.matchMedia(
        '(prefers-color-scheme: dark)'
      ).matches;
      this.theme.set({ mode: prefersDark ? 'dark' : 'light', color: 'orange' });
    }
  }

  private _setTheme(): void {
    localStorage.setItem('theme', JSON.stringify(this.theme()));
    this._setThemeClass();
  }

  private _setThemeClass(): void {
    document.querySelector('html')!.className = this.theme().mode;
    document
      .querySelector('html')!
      .setAttribute('data-theme', this.theme().color);
  }
}
